import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { BaasicTable, TableFilter, EmptyState } from 'core/components';
import EmptyIcon from 'themes/assets/img/building-modern.svg';
import { ApplicationListLayout, Content } from 'core/layouts';

function ESignPreferenceListTemplate({ eSignPreferenceListViewStore }) {
    const {
        tableLoading,
        tableStore,
        queryUtility,
        authorization
    } = eSignPreferenceListViewStore;
    return (
        <ApplicationListLayout store={eSignPreferenceListViewStore}>
            <Content emptyRenderer={renderEmpty()} >
                <div className='u-mar--bottom--sml'>
                    <TableFilter queryUtility={queryUtility} />
                </div>
                <div className="card--table">
                    <BaasicTable
                        tableStore={tableStore}
                        loading={tableLoading}
                        authorization={authorization}
                    />
                </div>
            </Content>
        </ApplicationListLayout>
    )
}

function renderEmpty() {
    return <EmptyState image={EmptyIcon} title='ESIGN_PREFERENCE.LIST.EMPTY_STATE.TITLE' description='ESIGN_PREFERENCE.LIST.EMPTY_STATE.DESCRIPTION' />
}

ESignPreferenceListTemplate.propTypes = {
    eSignPreferenceListViewStore: PropTypes.object
};

export default defaultTemplate(ESignPreferenceListTemplate);
